































import { Prop, Component, Vue } from "vue-property-decorator";
import { Weather } from "@/api/weather-api";
import WeatherIcon from "@/components/WeatherIcon.vue";
import getWeatherURL from "@/helpers/weather-helper";

@Component({
  components: {
    WeatherIcon
  }
})
export default class WeathersIcon extends Vue {
  @Prop({ required: true }) weathers!: Weather[];
  @Prop({ required: true }) latitude!: number;
  @Prop({ required: true }) longitude!: number;

  getWeatherURL() {
    return getWeatherURL(this.latitude, this.longitude);
  }

  viewDate(index: number, now: Date) {
    now = new Date();
    now.setDate(now.getDate() + index);
    return now.getDate();
  }

  weatherType(index: number) {
    if (this.weathers.length === 0) return "";
    const type = this.weathers[index].type;
    if (type) {
      return String(type);
    } else {
      return "";
    }
  }
}
